import { render, staticRenderFns } from "./Error408.vue?vue&type=template&id=2328d9b9&"
var script = {}
import style0 from "./Error408.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports